import { axiosInstance } from '../base.api';
import { paths } from '../paths';
import { BreakfastsType } from 'services/api/type/breakfasts.type';

export const getBreakfasts = (date: string): Promise<BreakfastsType[]> => {
  return axiosInstance.get(paths.getBreakfasts(date)).then(item => item.data.data);
};
